import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import RecursivePropertyPDF from '../components/RenderJSONpdf'

const CheckComprot = ({ comprotCheck }) => {
  const { t } = useTranslation(['common'])
  const details = comprotCheck?.checkDetails?.ComprotProcesses || {}
  const processes = details?.ComprotProcesses || []
  const hasChecks = Array.isArray(processes) && processes.length > 0
  const checkLength = Array.isArray(processes) ? processes.length : 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:comprotProcesses')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label="Processo" />
      </Paper>

      <CheckDetailTitle
        email={comprotCheck?.email}
        status={comprotCheck?.status}
        createdAt={comprotCheck?.createdAt}
        updatedAt={comprotCheck?.updatedAt}
      />

      {Object.keys(details).length > 0 && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <RecursivePropertyPDF property={{
              TotalNumberOfProcesses: details.TotalNumberOfProcesses,
              TotalNumberOfMovements: details.TotalNumberOfMovements,
              FirstMovementDate: details.FirstMovementDate,
              LastMovementDate: details.LastMovementDate,
              // RawResultFile: details.RawResultFile,
            }} rootProperty={true} />
          </Paper>
        </TimelineDotLine>
      )}

      {hasChecks &&
        processes.map((proc, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <RecursivePropertyPDF property={proc} rootProperty={true} />
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckComprot
